import BaseApi from "../../../services/baseApi";

class Reporting {

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/smsReport/list',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(params){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:params,
            url: '/private/smsReport/search',
            headers: {'Content-Type': 'application/json'},
        })

     }



}
export default new Reporting();
